import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input } from 'reactstrap';
import './TotalCss.css'
import './FetchData.css';
import { api_url } from "./globalFunction/global_string";
import Swal from 'sweetalert2';
import axios from 'axios';

export class FetchDataUserlocalNetSetTable extends Component {
  static displayName = FetchDataUserlocalNetSetTable.name;

  constructor(props) {
    super(props);
    this.state = {
      fetchDataUserlocalNetSetTable: props.fetchDataUserlocalNetSetTable,
      isFetchDataUserlocalNetSetTable: props.isFetchDataUserlocalNetSetTable,
      forecasts: [],
      loading: true,
      modal: false,
      editingItem: null,
      addModal: false,
      localnetname: '',
      scanOptions: {
        tenable_page: false,
      }
    };

    this.openAddModal = this.openAddModal.bind(this);
    this.closeAddModal = this.closeAddModal.bind(this);
    this.savelocalnetname = this.savelocalnetname.bind(this);
    this.openRegisterModal = this.openRegisterModal.bind(this);
    this.closeRegisterModal = this.closeRegisterModal.bind(this);
    this.saveChanges = this.saveChanges.bind(this);
  }


  openRegisterModal(item) {
    console.log(item)
    this.setState({
      modal: true,
      editingItem: item,
      selectedlocalnetname: item.local_net_name,
      selectedunitname: item.local_unit_name,
      local_net_id: item.local_net_id,
      scanOptions: {
        tenable_page: item.tenable_page,
      }
    });
  }

  closeRegisterModal() {
    this.setState({ modal: false });
  }

  openAddModal() {
    this.setState({ addModal: true });
  }

  closeAddModal() {
    this.setState({ addModal: false });
  }
  handleDelete = (local_net_id) => {
    Swal.fire({
      title: '確定要刪除這個區網嗎？',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '確定',
      cancelButtonText: '取消'
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append('local_net_id', local_net_id);


        fetch(api_url + '/api/JRCC/DeleteLocalNetId', {
          method: 'POST',
          headers: { "Authorization": localStorage.getItem('accessToken') },
          body: formData
        })
          .then(response => response.json())
          .then(result => {
            if (result.statusCode === 200) {
              Swal.fire('成功', '項目已成功刪除', 'success');

              this.populateWeatherData();
            } else {
              Swal.fire('錯誤', `${result.row}`, 'error');
            }
          })
          .catch(error => {
            console.log('Error fetching JSON:', error);
          });
      }
    })
  }

  async saveChanges() {
    const selectedunitname = JSON.stringify(this.state.selectedunitname);

    const formData = new FormData();
    formData.append('local_net_id', this.state.local_net_id);
    formData.append('local_net_name', this.state.selectedlocalnetname);
    formData.append('local_unit_name', selectedunitname);

    //新增頁面設定
    formData.append('tenable_page', this.state.scanOptions.tenable_page);

    axios.post(api_url + '/api/JRCC/PostLocalUnitId', formData, {
      method: 'POST',
      headers: {
        "Authorization": localStorage.getItem('accessToken'),
        "Content-Type": "multipart/form-data"
      }
    })
      .then(response => {
        console.log(response)
        if (response.data.statusCode === 200) {
          Swal.fire('成功', `${response.data.row}`, 'success');
          this.populateWeatherData();
          this.closeRegisterModal();
        } else {
          Swal.fire('錯誤', `${response.data.row}`, 'error');
        }

        this.setState({ addModal: false, localnetname: '' });
      })
  }



  async savelocalnetname() {
    const formData = new FormData();
    formData.append('local_net_name', this.state.localnetname);
    axios.post(api_url + '/api/JRCC/PostLocalNetId', formData, {
      method: 'POST',
      headers: {
        "Authorization": localStorage.getItem('accessToken'),
        "Content-Type": "multipart/form-data"
      }
    })
      .then(response => {
        console.log(response)
        if (response.data.statusCode === 200) {
          Swal.fire('成功', `${response.data.row}`, 'success');
          this.populateWeatherData();
        } else {
          Swal.fire('錯誤', `${response.data.row}`, 'error');
        }

        this.setState({ addModal: false, localnetname: '' });
      })
  }


  componentDidMount() {
    this.populateWeatherData();
  }


  renderTableHeader() {
    return (
      <thead>
        <tr>
          <th className='nancy_table_width10'>
            <div className="nancy-table-topC">操作</div></th>
          <th className='nancy_table_width10'>
            <div className="nancy-table-top">使用者區網名稱</div></th>
          <th className='nancy_table_width65'>
            <div className="nancy-table-topC">使用者單位名稱</div></th>
          <th className='nancy_table_width15'>
            <div className="nancy-table-topC">掃描設定</div></th>
        </tr>
      </thead>
    );
  }

  renderTableBody(forecasts) {
    return (
      <tbody>
        {forecasts.map(forecast => {
          const hasScanSettings = forecast.tenable_page; // 檢查 tenable_page 狀態

          return (
            <tr key={forecast.local_net_name}>
              <td>
                <Button type="modify" className="mx-1 d-inline" onClick={() => this.openRegisterModal(forecast)}>編輯</Button>
                <Button type="delete" className="mx-1 d-inline" onClick={() => this.handleDelete(forecast.local_net_id)}>刪除</Button>
              </td>
              <td>{forecast.local_net_name}</td>
              <td>{forecast.local_unit_name}</td>
              <td>
                {hasScanSettings && '主機掃描'}
              </td>
            </tr>
          );
        })}
      </tbody>
    );
  }


  render() {
    let contents = this.state.loading
      ? <p><em>Loading...</em></p>
      : this.renderTableBody(this.state.forecasts);
    return (
      <div className='mt-2'>
        <div style={{ textAlign: 'right' }}>
          <Button color="success" className="mb-2" onClick={this.openAddModal}>新增</Button>
        </div>
        <table id='tablelabel' className='table table-striped table-bordered dt-responsive nowrap vertical-align-center' aria-labelledby="tableLabel">
          {this.renderTableHeader()}
          {contents}
        </table>
        <Modal isOpen={this.state.modal} toggle={this.closeRegisterModal}>
          <ModalHeader toggle={this.closeRegisterModal}>修改資料</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label for="userName">區網名稱</Label>
              <Input type="text" id="userName" value={this.state.selectedlocalnetname} onChange={e => this.setState({ selectedlocalnetname: e.target.value.trim() })} />
            </FormGroup>
            <FormGroup>
              <Label for="unitname">單位名稱</Label>
              <Input type="textarea" id="unitname" rows="4" value={this.state.selectedunitname} onChange={e => this.setState({ selectedunitname: e.target.value.trim() })} />
            </FormGroup>

            <FormGroup>
              <Label>掃描設定</Label>
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    checked={this.state.scanOptions.tenable_page}
                    onChange={e => this.setState({ scanOptions: { ...this.state.scanOptions, tenable_page: e.target.checked } })}
                  />{' '}
                  主機掃描
                </Label>
              </FormGroup>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.saveChanges}>儲存</Button>{' '}
            <Button color="secondary" onClick={this.closeRegisterModal}>取消</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.addModal} toggle={this.closeAddModal}>
          <ModalHeader toggle={this.closeAddModal}>新增區網名稱</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label for="localnetname">區網名稱</Label>
              <Input type="text" id="localnetname" value={this.state.localnetname} onChange={e => this.setState({ localnetname: e.target.value.trim() })} />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.savelocalnetname}>儲存</Button>
            <Button color="secondary" onClick={this.closeAddModal}>取消</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }

  async populateWeatherData() {
    const formData = new FormData();
    formData.append("current_user_type", this.props.fetchedData.current_user_type);
    formData.append("local_net_id", this.props.fetchedData.login_user_net_id);

    await fetch(this.props.fetchedData.apiUrl, {
      method: "POST",
      headers: { "Authorization": localStorage.getItem('accessToken') },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        let arr_status = [String(data.statusCode), data.row, data.detail];
        const rows = Array.isArray(arr_status[1]) ? arr_status[1] : [arr_status[1]];

        const combinedRows = rows.reduce((acc, row) => {
          if (!acc[row.local_net_id]) {
            acc[row.local_net_id] = {
              local_net_name: row.local_net_name,
              local_net_id: row.local_net_id,
              local_unit_names: [row.local_unit_name],
              tenable_page: row.tenable_page !== undefined ? row.tenable_page : false,
            };
          } else {
            acc[row.local_net_id].local_unit_names.push(row.local_unit_name);
          }
          return acc;
        }, {});

        const forecasts = Object.values(combinedRows).map(row => ({
          local_net_name: row.local_net_name,
          local_unit_name: row.local_unit_names.join(","),
          local_net_id: row.local_net_id,
          tenable_page: row.tenable_page,
        }));

        this.setState({ forecasts: forecasts, loading: false });
      })
      .catch(error => {
        console.log('Error fetching JSON:', error);
      });
  }

}  